import axios from "axios";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { AiFillCloseCircle } from "react-icons/ai";

const EditStatusModal = ({ issue, isOpen, onClose, editStatusChanged }) => {
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    reset,
    clearErrors,
    formState: { errors },
  } = useForm({
    defaultValues: {
      resolvedDate: new Date(),
      issueStatus: issue.issueStatus || "In Progress",
    },
  });

  useEffect(() => {
    if (issue) {
      // setValue("resolvedDate", issue.resolvedDate?.slice(0, 10));
      setValue("issueStatus", issue.issueStatus);
    }
  }, [issue]);
  console.log("theToEditIssue", issue);

  const [isLoading, setIsLoading] = useState(false);
  const [errorStatus, setErrorStatus] = useState("");

  const closeModal = () => {
    onClose(); // Close the modal
    clearErrors();
    setErrorStatus("");
    setValue("issueStatus", issue.issueStatus);
  };

  const onSubmit = (data) => {
    if (data.issueStatus === "In Progress") {
      setErrorStatus("Please select a status");
      return;
    }

    setIsLoading(true);
    console.log("Form Data Submitted: ", data);

    let config = {
      method: "put",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/issues/update-issuestaus/${issue._id}`,
      headers: {},
      data: data,
    };

    console.log("config", issue._id);

    axios
      .request(config)
      .then((response) => {
        setIsLoading(false);
        console.log("------> issues ", response.data);
        toast.success(response.data.message);
        editStatusChanged(); // update status on ui by calling getAllIssues Again
        // onSave({ ...issue, ...data });
        closeModal(); // Close the modal
      })
      .catch((error) => {
        setIsLoading(false);
        console.log(error);
        toast.error(error.message);
        editStatusChanged(); // update status on ui by calling getAllIssues Again
        // onSave({ ...issue, ...data });
        closeModal(); // Close the modal
      });
  };

  // Watch issueStatus to highlight the selected button
  const issueStatus = watch("issueStatus");

  return (
    isOpen && (
      <div className="fixed inset-0 bg-black/50 backdrop-blur-sm  p-4 flex items-center justify-center  bg-opacity-50 z-50">
        <div className="bg-white p-6 rounded-lg shadow-lg   max-w-xl relative">
          <h2 className="text-xl font-semibold text-center mb-4">
            Change Status
          </h2>

          <AiFillCloseCircle
            onClick={closeModal}
            className="cursor-pointer text-primaryColor absolute top-4 right-4"
            size={30}
          />

          {/* Form */}
          <form onSubmit={handleSubmit(onSubmit)}>
            {/* Resolved Date Input */}
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Issue Title
              </label>
              <span>{issue?.issueTitle}</span>
              {/* <input
                type="date"
                {...register("resolvedDate", {
                  required: "Resolved date is required",
                })}
                className={`w-full px-3 py-2 border rounded-lg text-gray-700 focus:outline-none focus:ring-1 ${
                  errors.resolvedDate
                    ? "border-red-500 focus:ring-red-500"
                    : "border-gray-300 focus:ring-blue-500"
                }`}
              />
              {errors.resolvedDate && (
                <p className="text-red-500 text-sm mt-1">
                  {errors.resolvedDate.message}
                </p>
              )} */}
            </div>

            {/* Issue Status Buttons */}
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Issue Status <span className="text-red-500">*</span>
              </label>
              <div className="flex gap-2">
                {["In Progress", "Resolved", "Invalidate"].map(
                  (statusOption) => (
                    <button
                      type="button"
                      key={statusOption}
                      onClick={() => {
                        setErrorStatus("");
                        setValue("issueStatus", statusOption);
                      }}
                      className={`px-4 py-2 text-xs md:text-lg rounded-lg font-medium ${
                        statusOption === "In Progress" &&
                        issueStatus === statusOption
                          ? "border border-yellow-800 bg-yellow-100 text-yellow-600"
                          : statusOption === "Resolved" &&
                            issueStatus === statusOption
                          ? "border border-green-800 bg-green-100 text-green-600"
                          : statusOption === "Invalidate" &&
                            issueStatus === statusOption
                          ? "border border-red-800 bg-red-100 text-red-600"
                          : "bg-gray-100 text-gray-700"
                      }   `}
                    >
                      {statusOption}
                    </button>
                  )
                )}
              </div>
              {/* {errors.issueStatus && (
                <p className="text-red-500 text-sm mt-1">
                  {errors.issueStatus.message}
                </p>
              )} */}
              {errorStatus && (
                <p className="text-red-500 text-sm mt-1">{errorStatus}</p>
              )}
            </div>

            {/* Action Buttons */}

            <div className="sm:col-span-2  flex justify-between gap-6 mt-6 tracking-wide">
              <button
                type="button"
                onClick={closeModal}
                className="bg-white w-full border text-xs sm:text-lg hover:bg-secondaryTextColor px-4 py-2 rounded-md"
              >
                Cancel
              </button>
              <button
                type="submit"
                className="bg-primaryBtnColor text-xs sm:text-lg hover:bg-primaryBtnHoverColor w-full text-white px-4 py-2 rounded-md"
              >
                Save
              </button>
            </div>
          </form>
        </div>

        {isLoading && (
          <div className="fixed inset-0 h-screen w-screen flex items-center justify-center bg-black bg-opacity-50">
            <span class="loader"></span>
          </div>
        )}
      </div>
    )
  );
};

export default EditStatusModal;
